import { render, staticRenderFns } from "./newEstate.vue?vue&type=template&id=d99cfcf0&scoped=true"
import script from "./newEstate.vue?vue&type=script&lang=js"
export * from "./newEstate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99cfcf0",
  null
  
)

export default component.exports